module.exports = __webpack_public_path__ + "static/media/chefchaouen.d238bd02.jpg";